var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('headComponents'),_c('div',{staticClass:"body_page"},[_c('router-view'),(_vm.routerName!='/home')?_c('footComponents'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }